<template>
  <div class="text-left wrapper-inside">
    <GoBackButton />
    <div class="bg-card">
      <h2>{{ $t('pages.hr.delegating-user-for-offer', 'You are delegating a user for this offer') }}</h2>
      <OfferInfoCard :current-offer="offer" />
    </div>
    <div class="bg-card">
      <h2>Enter candidate details</h2>
      <b-form-group
        class="col-md-12"
        :label="$t('inputs.first-name', 'First Name') + ' *'"
        label-for="first_name"
      >
        <b-form-input
          id="first_name"
          v-model="$v.user.first_name.$model"
          :state="$v.user.first_name.$dirty ? !$v.user.first_name.$error : null"
        />
      </b-form-group>
      <b-form-group
        class="col-md-12"
        :label="$t('inputs.last-name', 'Last Name') + ' *'"
        label-for="last_name"
      >
        <b-form-input
          id="last_name"
          v-model="$v.user.last_name.$model"
          :state="$v.user.last_name.$dirty ? !$v.user.last_name.$error : null"
        />
      </b-form-group>
      <b-form-group
        class="col-md-12"
        :label="$t('inputs.email.title', 'Email') + ' *'"
        label-for="email"
      >
        <b-form-input
          id="email"
          v-model="$v.user.email.$model"
          :state="$v.user.email.$dirty ? !$v.user.email.$error : null"
        />
      </b-form-group>
      <b-form-group
        class="col-md-12"
        :label="$t('inputs.phone.title-full', 'Phone') + ' *'"
        label-for="phone"
      >
        <b-form-input
          id="phone"
          v-model="$v.user.phone.$model"
          :state="$v.user.phone.$dirty ? !$v.user.phone.$error : null"
        />
      </b-form-group>
      <b-form-group
        class="col-md-12"
        :label="$t('pages.my-account.profile.edit-profile-form.name.label', 'Name') + ' *'"
        label-for="file-input"
      >
        <b-form-file
          id="file-input"
          v-model="$v.user.document.$model"
          :state="$v.user.document.$dirty ? !$v.user.document.$error : null"
          :placeholder="$t('pages.user-cv.document.modal.select-file', 'Select a file')"
          :drop-placeholder="$t('pages.user-cv.document.modal.drop-file', 'Drop file here...')"
          :browse-text="$t('generic.browse', 'Browse')"
        />
      </b-form-group>
      <b-form-group class="col-md-12 text-right">
        <b-button
          variant="success"
          class="mr-1"
          @click="validate"
        >
          {{ $t('generic.send') }}
        </b-button>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import GoBackButton from '@/components/jobs/shared/GoBackButton';
import OfferInfoCard from '@/components/jobs/public/offerInfoCard';
import { required, email } from "vuelidate/lib/validators";

const lessThanTwoMb = (value) => { if(!value) return false; else return value.size <= 2 * 1000 * 1000 };
const goodFileFormat = (value) => {
  if(!value)
    return false;
  else {
    return value.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        value.type === "application/msword" ||
        value.type === "application/pdf";
  }
};

export default {
  components: {
    GoBackButton,
    OfferInfoCard,
  },
  data() {
    return {
      offerId: null,
      offer: null,
      user: {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        document: null
      },
      uploadPercentage: 0
    }
  },
  validations: {
    user: {
      first_name: { required },
      last_name: { required },
      email: { required, email },
      phone: { required },
      document: { required, lessThanTwoMb, goodFileFormat  }
    }
  },
  mounted() {
    this.offerId = this.$route.params.id;
    this.getOffer();
  },
  methods: {
    getOffer() {
      this.axios.get('/offer/one/' + this.offerId)
          .then( response => {
            this.offer = response.data;
          })
          .catch();
    },
    validate() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$toastNotification('danger', '', this.$t('pages.contact-us.validation.error', 'Please correct the errors in the form'));
        return false;
      } else {
        this.cvUpload(this.user.document);
        this.sendForm();
        return true;
      }
    },
    cvUpload(file) {
      const fd = new FormData();
      fd.append('category', 'external_candidates');
      fd.append('file', file);

      // Upload a file
      this.axios
          .post('/files/upload', fd, {
            headers: {
              'Content-type': 'multipart/form-data'
            },
            onUploadProgress: function( progressEvent ) {
              this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
            }.bind(this)
          })
          .then( (response) => {
            this.sendForm(response.data);
            this.uploadPercentage = 0;
          })
          .catch( (error) => {
            this.$toastNotification('danger', '', error.response.data.error);
          })
    },
    sendForm(fileObj) {
      let form = this.user;
      form.offerId = this.offerId;
      form.documentId = fileObj.id;

      this.axios.post('/delegate-external/user', form)
          .then( () => {
            this.$router.push({ name: "all-offers" });
          })
          .catch();
    }
  }
}
</script>
